import { TrustSchema } from "../types/trust.js";
import { TrustOidSchema } from "../types/trustOid.js";
import { lcrBrazil } from "./londonCareRecord.js";
import { leadingEdgeTrust, leadingEdgeTrustTwo } from "./organisations.js";
export const trustA = TrustSchema.parse({
    id: "23293186-cba3-429d-bd72-48bed4036774",
    name: "Trust A",
    address: "123 Trust St, Trustville",
    postalCode: "TST 1AA",
    odsCode: "TSTA",
    emhaOrgId: leadingEdgeTrust.id,
});
export const trustB = TrustSchema.parse({
    id: "c7895164-e269-4aac-a750-e0368612c21d",
    name: "Trust B",
    address: "456 Trust Ave, Trusttown",
    postalCode: "TST 1AB",
    odsCode: "TSTB",
    emhaOrgId: leadingEdgeTrustTwo.id,
});
const trustC = TrustSchema.parse({
    id: "a11e3879-8f00-47b2-86e6-c57be5188b68",
    name: "Trust C",
    address: "789 Trust Blvd, Trust City",
    postalCode: "TST 1AC",
    odsCode: "TSTC",
});
export const defaultTrusts = [trustA, trustB, trustC];
const trustAOid = TrustOidSchema.parse({
    trustId: trustA.id,
    oid: "1.2.826.0.1.3680043.8.498.1000",
    lcrInstanceId: lcrBrazil.id,
});
const trustBOid = TrustOidSchema.parse({
    trustId: trustB.id,
    oid: "1.2.826.0.1.3680043.8.498.1001",
    lcrInstanceId: lcrBrazil.id,
});
export const defaultTrustOids = [trustAOid, trustBOid];
//# sourceMappingURL=trusts.js.map